import Vue from "vue";
import VueGtag from "vue-gtag";

// Config gtag to call google analytics API
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GTAG_MEASUREMENT_ID }
});

export default {}
